import { useCallback } from 'react';
import { useCreateReviewMutation } from '../graphql';

export interface ICreateReviewInput {
    sku: string;
    nickname: string;
    summary: string;
    text: string;
    ratings: Array<{ id: string; value_id: string }>;
}

export const useCreateReviewAction = () => {
    const [createReviewMutation, createReviewMutationResult] =
        useCreateReviewMutation();

    const createReview = useCallback(
        async (review: ICreateReviewInput) => {
            const resp = await createReviewMutation({
                variables: review,
            });
            return resp;
        },
        [createReviewMutation]
    );
    return [createReview, createReviewMutationResult] as const;
};
